<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'UiGridItem',
};
</script>

<style scoped>

</style>
